import { Color } from "./helpers";

export type URI = string;

export type ZoneDimensions = Readonly<{
  maxX: number;
  maxY: number;
  minX: number;
  minY: number;
  cellType?: string;
  rightBorderImplicit?: boolean;
  topBorderImplicit?: boolean;
  bottomBorderImplicit?: boolean;
  leftBorderImplicit?: boolean;
}>;
export type Zone = ZoneDimensions &
  Readonly<{
    cells?: ReadonlyArray<ZoneDimensions>;
    confidence: number;
    humanGenerated: boolean;
    label: string;
  }>;

export type ZoneWithCells = Zone &
  Readonly<{
    cells: Required<Zone["cells"]>;
  }>;

export type Page = Readonly<{
  confidence?: number;
  height?: number;
  index: number;
  width?: number;
  zones: ReadonlyArray<Zone>;
}>;

type BoundingBox = [number, number, number, number];
type Cell = {
  x1:number,
  y1:number,
  x2:number,
  y2:number,
  cellType: string
  rightBorderImplicit: boolean;
  topBorderImplicit: boolean;
  bottomBorderImplicit: boolean;
  leftBorderImplicit: boolean;
}
export type ApiZone = Readonly<{
  box: BoundingBox;
  class: string;
  scores: number;
  subclass: string;
  cells?: ReadonlyArray<BoundingBox>;
  nuCells?: ReadonlyArray<Cell>
}>;

export type ApiPage = Readonly<{
  page_confidence: number;
  predictions: ReadonlyArray<ApiZone>;
}>;

interface IZoningPageMetadata {
  images: {
    height: number;
    width: number;
  };
}

export interface IZoningMetadata {
  pages: Array<IZoningPageMetadata>;
}

export interface ZoningLabel {
  color: Color;
  group: string;
}
export interface ZoningTaxonomy {
  [child: string]: ZoningLabel;
}
export interface ColorGroup {
  groupKey: keyof ZoningColors;
  groupColors: Color[];
  groupColorIndex: number;
} 
export interface ZoningColors {
  text: Color[];
  image: Color[];
  table: Color[];
  math: Color[];
}
export const TaxonomyColors : ZoningColors  = {
  text: [
		Color.fromString("#0000ff80"),    
		Color.fromString("#0046e480"),
		Color.fromString("#DD002080"),
		Color.fromString("#009de080"),
		Color.fromString("#00da9880"),
		Color.fromString("#8CC23D80"),
		Color.fromString("#09845880"),
		Color.fromString("#03382780"),
		Color.fromString("#4c998180"),
		Color.fromString("#c0b2e580"),
	],
  image: [
    Color.fromString("#60004080"),
    Color.fromString("#8a2be280"),
    Color.fromString("#da1d8180"),
    Color.fromString("#ff000080"),
    Color.fromString("#ff00ff80"),
    Color.fromString("#EF8CBA80"),
    Color.fromString("#ffcce680"),
  ],
  table: [
    Color.fromString("#ffff0080"),
		Color.fromString("#64640080"),
		Color.fromString("#ff790080"),
		Color.fromString("#7a3a0080"),
		Color.fromString("#8b670080"),
		Color.fromString("#ffbd0080")
	],
  math: [
    Color.fromString("#8b451380")
	],
};
export const DEFAULT_TAXONOMY: ZoningTaxonomy = {
  text: {
    color: Color.fromString("#0000ff"),
    group: "text",
  },
  image: {
    color: Color.fromString("#ff00ff"),
    group: "image",
  },
  table: {
    color: Color.fromString("#ffff00"),
    group: "table",
  },
  math: {
    color: Color.fromString("#8b4513"),
    group: "math",
  }
};

export type SavePage = (page: number, contents: ApiPage, showMessage: boolean, readonly: boolean) => Promise<void>;
export type SubmitJob = () => Promise<void>;

export enum JobState {
  Default,
  Saving,
  Submitting,
}
